import React from 'react';
import {Select, styled} from '@volkswagen-onehub/components-core';
import {getTranslations} from '../../translations';
import { useAppliedFilterStore } from '../../store/filtersv2';
import { SortBy } from '../../types/enums/sort-by';

const SelectWrapper = styled.div`
  grid-column: 2 / 3;
  grid-row: 1 / 2;
  align-self: end;

  @media screen and (max-width: 590px) {
    grid-column: 1 / 2;
    grid-row: 2 / 3;
  }
`;

export const SortDropdown = () => {
  const { labels } = getTranslations();

  const { applied, applyFilters } = useAppliedFilterStore();
  const { category } = applied;

  const onChangeFilter = (
    event: React.SyntheticEvent<HTMLSelectElement, Event>
  ) => {
    const value = event.currentTarget.value as SortBy;

    switch (value) {
      case SortBy.LOWEST_PRICE:
        applyFilters({
          sort_price: "asc",
          sort_added: undefined,
          sort_mileage: undefined,
          sort_by: SortBy.LOWEST_PRICE
        });
        break;
      case SortBy.HIGHEST_PRICE:
        applyFilters({
          sort_price: "desc",
          sort_added: undefined,
          sort_mileage: undefined,
          sort_by: SortBy.HIGHEST_PRICE
        });
        break;
      case SortBy.NEWLY_ADDED:
        applyFilters({
          sort_price: undefined,
          sort_added: "asc",
          sort_mileage: undefined,
          sort_by: SortBy.NEWLY_ADDED
        });
        break;
      case SortBy.LOWEST_MILEAGE:
        applyFilters({
          sort_price: undefined,
          sort_added: undefined,
          sort_mileage: "asc",
          sort_by: SortBy.LOWEST_MILEAGE
        });
        break;
      case SortBy.DISTANCE:
      default:
        applyFilters({
          sort_price: undefined,
          sort_added: undefined,
          sort_mileage: undefined,
          sort_by: SortBy.DISTANCE
        });
        break;
    }
  };

  return (
    <SelectWrapper>
      <Select
        label={labels.sort_by}
        onChange={(e) => onChangeFilter(e)}
        value={applied?.sort_by}
      >
        <option
          value={SortBy.DISTANCE}
        >
          {labels.distance}
        </option>
        <option
          value={SortBy.LOWEST_PRICE}
        >
          {labels.lowest_price}
        </option>
        <option
          value={SortBy.HIGHEST_PRICE}
        >
          {labels.highest_price}
        </option>
        <option
          value={SortBy.NEWLY_ADDED}
        >
          {labels.newly_added}
        </option>
        {
          category?.length === 1 && (category?.includes('used') || category?.includes('certified'))
          ? <option
            value={SortBy.LOWEST_MILEAGE}
            >
              {labels.mileage}
            </option>
          : null
        }
      </Select>
    </SelectWrapper>
  );
};
